import { i18n } from '@lingui/core';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/en';

// TODO: cambiar cuando se pase a producción "idiomas"
// export const DEFAULT_LOCALE = navigator.language.startsWith('en') ? 'en' : 'es';
export const DEFAULT_LOCALE = 'es';

// Hasta que hay un locale activo, el I18nProvider de Lingui no dibuja nada.
export const activateLocale = async (locale: string) => {
  const { messages } = await import(`../../locales/${locale}.po`);

  i18n.load(locale, messages);
  i18n.activate(locale);
  dayjs.locale(locale);
};
